import { render, staticRenderFns } from "./AsyncGetterDevPage.vue?vue&type=template&id=1a7037e1&"
import script from "./AsyncGetterDevPage.vue?vue&type=script&lang=js&"
export * from "./AsyncGetterDevPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports